import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { PytCustTblService } from '../pyt-cust-tbl.service';


@Directive({
  selector: '[appPytCustTblPager]',
})
export class PytCustTblPagerDirective implements OnChanges {
  @Input() tableOptions: any;
  @Input() totalPages: any;
  @Input() currentPage: any;
  $pagination: any;
  $adjacents: any = 3;

  constructor(
    private elRef: ElementRef,
    private renderer: Renderer2,
    private _PytCustTblService: PytCustTblService
  ) { }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    this.setPager();
  }
  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    this.setPager();
  }

  setPager() {
    let divEle = this.elRef.nativeElement;
    const childElements = this.elRef.nativeElement.children;
    for (let child of childElements) {
      this.renderer.removeChild(this.elRef.nativeElement, child);
    }

    let $lastpage = this.totalPages;
    let $page = this.currentPage;
    this.$pagination = '';

    if ($lastpage > 1) {
      if ($lastpage < 7 + this.$adjacents * 2) {
        for (let $counter = 1; $counter <= $lastpage; $counter++) {
          if ($counter == $page) {
            this.setCurrent($counter, divEle);
          } else this.setCounter($counter, divEle);
        }
      } else if ($lastpage > 5 + this.$adjacents * 2) {
        if ($page < 1 + this.$adjacents * 2) {
          for (
            let $counter = 1;
            $counter < 4 + this.$adjacents * 2;
            $counter++
          ) {
            if ($counter == $page) {
              this.setCurrent($counter, divEle);
            } else this.setCounter($counter, divEle);
          }
          this.setLastPage($lastpage, divEle);
        } else if (
          $lastpage - this.$adjacents * 2 > $page &&
          $page > this.$adjacents * 2
        ) {
          this.setFirstPage(divEle);
          for (
            let $counter = $page - this.$adjacents;
            $counter <= $page + this.$adjacents;
            $counter++
          ) {
            if ($counter == $page) {
              this.setCurrent($counter, divEle);
            } else this.setCounter($counter, divEle);
          }
          this.setLastPage($lastpage, divEle);
        } else {
          this.setFirstPage(divEle);
          for (
            let $counter = $lastpage - (2 + this.$adjacents * 2);
            $counter <= $lastpage;
            $counter++
          ) {
            if ($counter == $page) {
              this.setCurrent($counter, divEle);
            } else this.setCounter($counter, divEle);
          }
        }
      }
    }
  }

  setFirstPage(divEle: any) {
    const aTag1 = this.renderer.createElement('a');
    const aTagText = this.renderer.createText('1...');
    this.renderer.appendChild(aTag1, aTagText);
    this.renderer.appendChild(divEle, aTag1);
    this.renderer.listen(aTag1, 'click', (e) => {
      e.stopPropagation();
      this._PytCustTblService.dtUpdateByPagination(1, this.tableOptions);
    });
  }

  setCounter($counter: any, divEle: any) {
    const aTag2 = this.renderer.createElement('a');
    const aTagText = this.renderer.createText($counter.toString());
    this.renderer.addClass(aTag2, 'click');
    this.renderer.appendChild(aTag2, aTagText);
    this.renderer.appendChild(divEle, aTag2);
    this.renderer.listen(aTag2, 'click', (e) => {
      e.stopPropagation();
      this._PytCustTblService.dtUpdateByPagination($counter, this.tableOptions);
    });
  }

  setCurrent($counter: any, divEle: any) {
    this.$pagination += '<span>' + $counter + '</span>';
    const span = this.renderer.createElement('span');
    const spanText = this.renderer.createText($counter.toString());
    // this.renderer.setStyle(span, 'font-size', '20px');
    this.renderer.appendChild(span, spanText);
    this.renderer.appendChild(divEle, span);
  }

  setLastPage($lastpage: any, divEle: any) {
    const aTag3 = this.renderer.createElement('a');
    const aTagText = this.renderer.createText('...' + $lastpage);
    this.renderer.appendChild(aTag3, aTagText);
    this.renderer.listen(aTag3, 'click', (e) => {
      e.stopPropagation();
      this._PytCustTblService.dtUpdateByPagination(
        +$lastpage,
        this.tableOptions
      );
    });
    this.renderer.appendChild(divEle, aTag3);
  }
}

// ----------------------------OLD CODE------------------------------

// config: {
//   showSort: true,
//   search: '',
//   sortBy: '',               //columns name || ''
//   sortDirection: "asc",     //asc || desc
//   itmeLengthStartFrom: 0,
//   totalCount: 0,
//   currentPage: 1,
//   totalPages: 0,
//   totalItmePerPage: 100,      // number
//   pagger: [
//     5, 10, 20, 25, 30, 100, 200
//   ],
//   fromRec: 0,
//   toRec: 0,
// },
// dtUpdateFnCallBack: async function () {

//   let data: any = await that.recordsearchFn();
//   if (data.statuscode == 200) {
//     that.tableOptions.dtRefresh(data);
//   }
// },
// dtRefresh: function (obj: any) {

//   that.tableOptions.records = obj.data;
//   let header: any = [];
//   if (obj.isheader) {
//     obj.isheader.map((val: any) => {
//       // if (val.is_show == '1') {
//       header.push(val);
//       // }
//     });
//   } else {
//     if (obj.data) {
//       let keyObj = obj.data[0];
//       for (const key in keyObj) {
//         const element = keyObj[key];
//         let obja = {
//           "name": element,
//           "value": element.toUpperCase(),
//           "is_show": 1,
//           "issort": 1
//         }
//         header.push(obja);
//       }
//     }
//   }

//   that.tableOptions.columns = header;

//   that.tableOptions.config.totalCount = +obj.recordsTotal;

//   that.tableOptions.config.totalPages = Math.ceil(that.tableOptions.config.totalCount / that.tableOptions.config.totalItmePerPage);

//   that.tableOptions.config.totalPages = that.tableOptions.config.totalPages ? that.tableOptions.config.totalPages : 0;

//   that.tableOptions.config.fromRec = obj.recordsTotal ? that.tableOptions.config.itmeLengthStartFrom + 1 : 0;

//   that.tableOptions.config.toRec = that.tableOptions.config.currentPage * that.tableOptions.config.totalItmePerPage;

//   that.tableOptions.config.toRec = that.tableOptions.config.toRec > that.tableOptions.config.totalCount ? that.tableOptions.config.totalCount : that.tableOptions.config.toRec;
//   that.tableOptionsCopy = that.tableOptions
// }





// setPager() {
//   const { nativeElement } = this.elRef;
//   const { totalPages, currentPage, $adjacents } = this;

//   // Clear existing pagination elements
//   while (nativeElement.firstChild) {
//     this.renderer.removeChild(nativeElement, nativeElement.firstChild);
//   }

//   if (totalPages <= 1) return;

//   if (totalPages < 7 + $adjacents * 2) {
//     for (let counter = 1; counter <= totalPages; counter++) {
//       this.setPage(counter, currentPage, nativeElement);
//     }
//   } else if (totalPages > 5 + $adjacents * 2) {
//     if (currentPage < 1 + $adjacents * 2) {
//       for (let counter = 1; counter < 4 + $adjacents * 2; counter++) {
//         this.setPage(counter, currentPage, nativeElement);
//       }
//       this.setLastPage(totalPages, nativeElement);
//     } else if (totalPages - $adjacents * 2 > currentPage && currentPage > $adjacents * 2) {
//       this.setFirstPage(nativeElement);
//       for (let counter = currentPage - $adjacents; counter <= currentPage + $adjacents; counter++) {
//         this.setPage(counter, currentPage, nativeElement);
//       }
//       this.setLastPage(totalPages, nativeElement);
//     } else {
//       this.setFirstPage(nativeElement);
//       for (let counter = totalPages - (2 + $adjacents * 2); counter <= totalPages; counter++) {
//         this.setPage(counter, currentPage, nativeElement);
//       }
//     }
//   }
// }

// setPage(counter: number, currentPage: number, container: HTMLDivElement) {
//   if (counter === currentPage) {
//     this.setCurrent(counter, container);
//   } else {
//     this.setCounter(counter, container);
//   }
// }
